import React from 'react'

export default function ContactSend() {
  return (
    <div class='contactSend'><h3 class='text-background'>Bedankt om te verzenden we nemen zo snel mogelijk met jullie contact op</h3></div>
  )
}
